import { render, staticRenderFns } from "./CreateSpaceModal.vue?vue&type=template&id=48fdc65a&"
import script from "./CreateSpaceModal.vue?vue&type=script&lang=ts&"
export * from "./CreateSpaceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src566367325/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fdc65a')) {
      api.createRecord('48fdc65a', component.options)
    } else {
      api.reload('48fdc65a', component.options)
    }
    module.hot.accept("./CreateSpaceModal.vue?vue&type=template&id=48fdc65a&", function () {
      api.rerender('48fdc65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreateSpaceModal.vue"
export default component.exports